import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';
import { MicroResponse } from 'src/app/main/pages/services/microservices/response/micro.response';
import { ProspectResponse } from 'src/app/main/pages/services/microservices/response/prospect.response';

import { ProspectRequest } from './microservices/request/prospect.request';
import { IdResponse } from './microservices/response/id.response';

@Injectable()
export class ProspectService {
  private gatewayApi = environment.IDEMPIER_GATEWAY;
  private prospectPerfil?: ProspectResponse;

  constructor(private http: HttpClient) {}

  //FUNCION REGISTRO MICROSERVICIOS PROSPECT
  prospectRegister(
    params: ProspectRequest,
  ): Observable<MicroResponse<IdResponse>> {
    return this.http.post<MicroResponse<IdResponse>>(
      `${this.gatewayApi}/v1/prospect`,
      params,
    );
  }

  searchProspectPerfil(
    cedula: string,
  ): Observable<MicroResponse<ProspectResponse>> {
    return this.http.get<MicroResponse<ProspectResponse>>(
      `${this.gatewayApi}/v1/prospect?cardId=${cedula}`,
    );
  }
  //ENVIO DE EMAIL DE CONFIRMACION
  sendEmail(id: number): Observable<MicroResponse<string>> {
    return this.http.post<MicroResponse<string>>(
      `${this.gatewayApi}/v1/prospect/${id}/email/message`,
      '',
    );
  }

  saveEmail(
    id: number,
    emailResquest: any,
  ): Observable<MicroResponse<boolean>> {
    return this.http.post<MicroResponse<boolean>>(
      `${this.gatewayApi}/v1/prospect/${id}/email`,
      emailResquest,
    );
  }

  checkPinCode(
    id: number,
    pinCode: string,
  ): Observable<MicroResponse<boolean>> {
    return this.http.get<MicroResponse<boolean>>(
      `${this.gatewayApi}/v1/prospect/${id}?pinCode=${pinCode}`,
    );
  }

  confirmation(param: any): Observable<MicroResponse<boolean>> {
    return this.http.post<MicroResponse<boolean>>(
      `${this.gatewayApi}/v1/prospect/confirmation`,
      param,
    );
  }
}
